module.exports = __webpack_public_path__ + "static/quick-roll-static-cec6ae14eafcb2f641c8f06e7cb4b604.png";